// This file was automatically generated from Excel data
// src/components/LocationDatabase.js

// Helper function for creating unique card keys
function createUniqueCardKey(card) {
  // Combine name and set for a unique identifier
  // For backward compatibility, return the ID if it's already globally unique
  if (card.id && card.id.includes('-')) {
    return card.id;
  }
  
  // If already has a uniqueId, use it
  if (card.uniqueId) {
    return card.uniqueId;
  }
  
  // Otherwise create a composite key using name and set
  return `${card.name}__${card.set || 'unknown'}`;
}

// Pre-populated location database
export const locationDatabase = [
  {
    "id": "203/232",
    "name": "Castle Bodhran",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "At the beginning of combat, each player can return a Mugic Card from their general discard pile to their hand.",
    "flavorText": "This strange stronghold is built in a style that might best be called \"bizzarechitecture.\"",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, Jimmy Tran",
    "imageUrl": "https://i.imgur.com/XbkLs3f.png",
    "uniqueId": "Castle Bodhran__dop"
  },
  {
    "id": "204/232",
    "name": "Castle Pillar",
    "subname": "",
    "set": "dop",
    "rarity": "ultra rare",
    "ability": "At the beginning of combat, if an engaged Creature has higher :wisdom:Wisdom than the opposing engaged Creature, put a :genericmugic: on it.",
    "flavorText": "",
    "unique": true,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/tLHVA0R.png",
    "uniqueId": "Castle Pillar__dop"
  },
  {
    "id": "205/232",
    "name": "Cordac Falls",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "ability": "At the beginning of combat, engaged Creatures gains 5 Energy.",
    "flavorText": "Cordac's teardrops plunge into the abyss with nary a splash or spray...",
    "unique": false,
    "initiative": "OverWorld",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/oV7ogkt.png",
    "uniqueId": "Cordac Falls__dop"
  },
  {
    "id": "206/232",
    "name": "Cordac Falls Plungepool",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "ability": "At the beginning of combat, deal 5 damage to engaged Creatures.",
    "flavorText": "...and strike the lake miles below, exploding outwards into the fray.",
    "unique": false,
    "initiative": "UnderWorld",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/bT6BPtI.png",
    "uniqueId": "Cordac Falls Plungepool__dop"
  },
  {
    "id": "207/232",
    "name": "Crystal Cave",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "If an engaged Creature has lower :speed:Speed than the opposing engaged Creature, it deals 0 damage on its first attack each combat.",
    "flavorText": "The ancient Mugicians mined the hardest substance in all of Perim to protect their mystical melodies.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Damien Labonte, Kevin Chai",
    "imageUrl": "https://i.imgur.com/0DMycSv.png",
    "uniqueId": "Crystal Cave__dop"
  },
  {
    "id": "208/232",
    "name": "Doors of the Deepmines",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "At the beginning of combat, Creatures with :water:Water gain 10 Energy.",
    "flavorText": "In a rare sign of solidarity, all four tribes guard the massive doors, hoping they never open again.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/YKFWpUt.png",
    "uniqueId": "Doors of the Deepmines__dop"
  },
  {
    "id": "209/232",
    "name": "Dranakis Threshold",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Mugic and activated abilities cannot be played.",
    "flavorText": "The few who have survived utter nary a word of what lies beyond.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Christopher Palesti, David Curiel",
    "imageUrl": "https://i.imgur.com/k5Mrj5w.png",
    "uniqueId": "Dranakis Threshold__dop"
  },
  {
    "id": "210/232",
    "name": "Everrain",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "ability": ":water:Water attacks deal an additional 5 damage.\r\nDamage dealt by :earth:Earth attacks is reduced by 5.",
    "flavorText": "Lake Ken-I-Po seeps through the UnderWorld ceiling in an unending reminder of the OverWorld's aqueous bounty.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/ntNkMd6.png",
    "uniqueId": "Everrain__dop"
  },
  {
    "id": "211/232",
    "name": "Eye of the Maelstrom",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "When this becomes the active Location, each player discards a Mugic Card.",
    "flavorText": "No wind, no sound - just madness.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/UiQl4db.png",
    "uniqueId": "Eye of the Maelstrom__dop"
  },
  {
    "id": "212/232",
    "name": "Fear Valley",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "At the beginning of combat, if an engaged Creature has lower :courage:Courage than the opposing engaged Creature, it loses 10 Energy.",
    "flavorText": "One night here means a lifetime of nightmares.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Andrew Bradshaw, Anthony Washington",
    "imageUrl": "https://i.imgur.com/MZNthqw.png",
    "uniqueId": "Fear Valley__dop"
  },
  {
    "id": "213/232",
    "name": "Forest of Life",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "ability": "At the beginning of combat, if an engaged Creature has higher :power:Power than the opposing engaged Creature, it gains 5 Energy.",
    "flavorText": "A place of perpetuity: nothing is born or perishes within.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Rudy Nebres, David Curiel",
    "imageUrl": "https://i.imgur.com/xydxrjW.png",
    "uniqueId": "Forest of Life__dop"
  },
  {
    "id": "214/232",
    "name": "Gigantempopolis",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "At the beginning of combat, put a :overworldmugic: on any engaged OverWorld Creatures.",
    "flavorText": "The ancient beings who once dwelled here faded into oblivion - proving indisputably that size doesn’t matter.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/jrd73kv.png",
    "uniqueId": "Gigantempopolis__dop"
  },
  {
    "id": "215/232",
    "name": "Glacier Plains",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Creatures must pay an additional :underworldmugic: to play UnderWorld Mugic Cards.",
    "flavorText": "This frozen, remote region is as harsh and forbidding as the UnderWorld's Lava Pond.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/qigkhho.png",
    "uniqueId": "Glacier Plains__dop"
  },
  {
    "id": "216/232",
    "name": "Gloomuck Swamp",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "ability": ":earth:Earth attacks deal an additional 5 damage.\r\nDamage dealt by :fire:Fire attacks is reduced by 5.",
    "flavorText": "For very different reasons both Crawsectus and Antidaeon choose to call this murky mess home.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Rudy Nebres, David Curiel",
    "imageUrl": "https://i.imgur.com/3SZWzaJ.png",
    "uniqueId": "Gloomuck Swamp__dop"
  },
  {
    "id": "217/232",
    "name": "Gothos Tower",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "ability": "Creatures not named Lord Van Bloot have 10 less :courage:Courage.\r\nLord Van Bloot has \"Invisibility: Strike 15.\"",
    "flavorText": "The horrific home of the harrowing Lord Van Bloot.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/8sI97QU.png",
    "uniqueId": "Gothos Tower__dop"
  },
  {
    "id": "218/232",
    "name": "Iron Pillar",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Battlegear have no abilities.",
    "flavorText": "The frequent quakes that rock the UnderWorld are blamed on the instability of this once-might prop.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/7GfZH7k.png",
    "uniqueId": "Iron Pillar__dop"
  },
  {
    "id": "219/232",
    "name": "Kiru City",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "ability": "OverWorld Creatures have an additional 10 Energy.",
    "flavorText": "The majestic capital of the OverWorld is named in memory of one of its greatest leaders.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/ZbYCdDx.png",
    "uniqueId": "Kiru City__dop"
  },
  {
    "id": "220/232",
    "name": "Lake Ken-I-Po",
    "subname": "",
    "set": "dop",
    "rarity": "ultra rare",
    "ability": "Each Mugic has \"Untargetable.\"",
    "flavorText": "Above the placid waters, Najarin's castle towers. A dim light flickers... and a mystery is born.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/HqdcFgL.png",
    "uniqueId": "Lake Ken-I-Po__dop"
  },
  {
    "id": "221/232",
    "name": "Lava Pond",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "ability": ":fire:Fire attacks deal an additional 5 damage.\r\nDamage dealt by :air:Air attacks is reduced by 5.\r\nCreatures named Magmon have \":fire:Fire 5.\"",
    "flavorText": "",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/6Ui54w4.png",
    "uniqueId": "Lava Pond__dop"
  },
  {
    "id": "222/232",
    "name": "Mipedim Oasis",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "ability": "Mipedian Creatures deal an additional 10 damage with their first attack each combat.",
    "flavorText": "For those struggling in the Mipedian Desert, this is a welcome sight. But it is what they can't see that will prove most dangerous.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/2BfuD6T.png",
    "uniqueId": "Mipedim Oasis__dop"
  },
  {
    "id": "223/232",
    "name": "Mount Pillar",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "ability": "When this becomes the active Location, activate Hive.",
    "flavorText": "The Danian homeland provides vital structural support to the UnderWorld ceiling, explaining why Chaor has resisted its demolition.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/Y3M93Oz.png",
    "uniqueId": "Mount Pillar__dop"
  },
  {
    "id": "224/232",
    "name": "Ravanaugh Ridge",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "ability": "At the beginning of combat, if a player controls an engaged Creature with :air:Air, that player can look at the top three cards of their Attack Deck, put one of them on top of that deck and the others on the bottom in any order.",
    "flavorText": "",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/gEEsV4O.png",
    "uniqueId": "Ravanaugh Ridge__dop"
  },
  {
    "id": "225/232",
    "name": "Riverlands",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "ability": "When a Creature deals :water:Water damage, heal 5 damage to it.",
    "flavorText": "No one has yet to reach the source of the rushing waters. Could the Cothica be where it all begins?",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/mRENwjK.png",
    "uniqueId": "Riverlands__dop"
  },
  {
    "id": "226/232",
    "name": "Runic Grove",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "ability": "Tribal Mugic cannot be played.",
    "flavorText": "Secret symbols or a simple secret? Many have been tantalized by what remains indecipherable to this day.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Anthony Washington",
    "imageUrl": "https://i.imgur.com/sFIrfSH.png",
    "uniqueId": "Runic Grove__dop"
  },
  {
    "id": "227/232",
    "name": "Stone Pillar",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Engaged UnderWorld Creatures pay 1 less :underworldmugic: to play their first Mugic this turn.",
    "flavorText": "Without the Pillars there would be no Over and Under, but simply one World.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/eZVYq97.png",
    "uniqueId": "Stone Pillar__dop"
  },
  {
    "id": "229/232",
    "name": "Stronghold Morn",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "At the beginning of combat, engaged Creatures gain :fire:Fire, :water:Water, :air:Air, and :earth:Earth.",
    "flavorText": "",
    "unique": true,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/pdEyJo1.png",
    "uniqueId": "Stronghold Morn__dop"
  },
  {
    "id": "228/232",
    "name": "The Storm Tunnel",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "ability": ":air:Air attacks deal an additional 5 damage.\r\nDamage dealt by :water:Water attacks is reduced by 5.",
    "flavorText": "Even those who cannot fly do so here.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Billy Ray Patton, Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/jQFQYFA.png",
    "uniqueId": "The Storm Tunnel__dop"
  },
  {
    "id": "230/232",
    "name": "UnderWorld City",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Attacks played by UnderWorld Creatures have \"Challenge :power:Power 15: Deal 5 damage.\"",
    "flavorText": "Not known for his creativity, Chaor nevertheless won the capital-naming contest for which he was also the judge.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/CAnyyXy.png",
    "uniqueId": "UnderWorld City__dop"
  },
  {
    "id": "231/232",
    "name": "UnderWorld Colosseum",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "ability": "Creatures with :fire:Fire deal an additional 10 damage on their first attack each combat.",
    "flavorText": "UnderWorlders have a simple way of settling arguments here: the one left standing is always right.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Rudy Nebres, Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/EtKYw4Z.png",
    "uniqueId": "UnderWorld Colosseum__dop"
  },
  {
    "id": "232/232",
    "name": "Wooden Pillar",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "ability": "Creatures must pay an additional :overworldmugic: to play OverWorld Mugic Cards.",
    "flavorText": "The Runic Grove takes root here, and UnderWorlders believe it grows even further down than up.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/Bc9Z5La.png",
    "uniqueId": "Wooden Pillar__dop"
  },
  {
    "id": "92/100",
    "name": "Carnival of Confusion",
    "subname": "",
    "set": "zoth",
    "rarity": "ultra rare",
    "ability": "When this becomes the active Location, Creatures lose all Elemental Types. If a Creature lost :fire:Fire, it gains :water:Water. If a Creature lost :water:Water, it gains :air:Air. If a Creature lost :air:Air, it gains :earth:Earth. If a Creature lost :earth:Earth, it gains :fire:Fire.\r\nElemental Attacks deal an additional 5 damage.",
    "flavorText": "",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, Jimmy Tran",
    "imageUrl": "https://i.imgur.com/Nlpg3Kk.png",
    "uniqueId": "Carnival of Confusion__zoth"
  },
  {
    "id": "94/100",
    "name": "Grand Hall of Muge's Summit",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "ability": "When a Mugic counter is removed from a Creature, Grand Hall of Muge's Summit deals 10 damage to the engaged Creature controlled by the same player.",
    "flavorText": "Muges rarely feel comfortable sharing their secrets.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/Gn5EubB.png",
    "uniqueId": "Grand Hall of Muge's Summit__zoth"
  },
  {
    "id": "95/100",
    "name": "Mount Pillar Reservoir",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "ability": "Creatures have \"Fireproof 10.\"\r\nDanian Creatures have \":water:Water 5.\"",
    "flavorText": "All Danians know that the Reservoir is the well-spring of life. It must be defended to the death.",
    "unique": false,
    "initiative": "Water",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/918hurz.png",
    "uniqueId": "Mount Pillar Reservoir__zoth"
  },
  {
    "id": "96/100",
    "name": "Oipont's Lookout",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "ability": "Creatures with :air:Air have :earth:Earth.\r\nIf Hive is Active, Danian Creatures have :air:Air and :earth:Earth.",
    "flavorText": "From high above, Danians can see deep into the heart of the UnderWorld, including invading armies days in advance.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/GrSB7L1.png",
    "uniqueId": "Oipont's Lookout__zoth"
  },
  {
    "id": "97/100",
    "name": "OverWorld Embassy at Mount Pillar",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "ability": "When this becomes the active Location, Uninfect all Creatures.",
    "flavorText": "Though adorned with oah and jij plants from his village, one look outside his window reminds Raznus that he's far from home.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/uCQUWAK.png",
    "uniqueId": "OverWorld Embassy at Mount Pillar__zoth"
  },
  {
    "id": "98/100",
    "name": "Queen's Gate",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "ability": "Creatures engaged with Scouts do not have and cannot gain Invisibility.",
    "flavorText": "\"Did you hear something moving? Did you see something moving? I think I just touched something moving...\"",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/uZSkcgI.png",
    "uniqueId": "Queen's Gate__zoth"
  },
  {
    "id": "99/100",
    "name": "Sands of the Unseen",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "ability": "Creatures with :air:Air have \"Invisibility: Strike 10.\"",
    "flavorText": "Danians seek the answers to Mipedian invisibility, but they realize too late that some secrets should remain mysteries.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/WYucDcF.png",
    "uniqueId": "Sands of the Unseen__zoth"
  },
  {
    "id": "100/100",
    "name": "Sha-Kree Flats",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "ability": "At the beginning of combat, engaged Elementalist Creatures gain an Elemental type of their controller's choice.",
    "flavorText": "Flat, dry, inhospitable. Perfect!",
    "unique": false,
    "initiative": "Mipedian",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/ZvbYcHm.png",
    "uniqueId": "Sha-Kree Flats__zoth"
  },
  {
    "id": "91/100",
    "name": "The Barracks",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "ability": "At the end of combat, if a Warrior you control was engaged that combat, you can relocate it to any unoccupied space on the Battleboard adjacent to it.",
    "flavorText": "Rest well tonight. Another harsh day awaits.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/V73UpZT.png",
    "uniqueId": "The Barracks__zoth"
  },
  {
    "id": "93/100",
    "name": "The Darkened Dunes",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "ability": "Creatures with :earth:Earth have \"Range\" and \"Swift 1.\"",
    "flavorText": "The dark whirlwind descends, enveloping you in its black, velvet grip... and never lets go.",
    "unique": false,
    "initiative": "Air",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/reJBN0d.png",
    "uniqueId": "The Darkened Dunes__zoth"
  },
  {
    "id": "91/100",
    "name": "Catacombs of the Conjurors",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "ability": "Damage dealt to Warbeast Creatures by Recklessness is reduced by 5.\r\nConjuror Creatures have \"Recklessness 5.\"",
    "flavorText": "Shunned by even the most tolerant of Mipedians, Conjurors continue to push the boundaries of Mugic.",
    "unique": false,
    "initiative": "Warbeast",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ThGY8dC.png",
    "uniqueId": "Catacombs of the Conjurors__ss"
  },
  {
    "id": "92/100",
    "name": "Forest of Life",
    "subname": "During Aichlyys",
    "set": "ss",
    "rarity": "uncommon",
    "ability": "Creatures do not have and cannot gain Invisibility.",
    "flavorText": "On those rare nights when the triad stars of Lup, Lec, and Teo shine above the forest, all secrets are brought to light.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/DEvGo7V.png",
    "uniqueId": "Forest of Life__ss"
  },
  {
    "id": "94/100",
    "name": "Indigo Grove",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "ability": "When this becomes the active Location, you can sacrifice a non-Conjuror Creature you control. If you do, return a Conjuror Creature Card in your general discard pile to play to any unoccupied space on the Battleboard.",
    "flavorText": "",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/VnfO1iL.png",
    "uniqueId": "Indigo Grove__ss"
  },
  {
    "id": "95/100",
    "name": "Iparu Jungle",
    "subname": "",
    "set": "ss",
    "rarity": "ultra rare",
    "ability": "When this becomes the active Location, flip a coin. If tails, shuffle Iparu Jungle into its controller's Location Deck and that player reveals a new active Location.\r\nMirage: At the beginning of combat, each engaged Creature in this space gains or loses Energy so its Energy is equal to its Scanned Energy.",
    "flavorText": "",
    "unique": false,
    "initiative": "Wisdom",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/aa7omq3.png",
    "uniqueId": "Iparu Jungle__ss"
  },
  {
    "id": "96/100",
    "name": "Mipedian Dew Farm",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "ability": "Scouts have :water:Water.\r\nEngaged Creatures with :water:Water have :genericmugic:: Heal 10 damage to target Creature.\"",
    "flavorText": "Under the sun, one drop is the difference between life and death.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/LRHjZ0T.png",
    "uniqueId": "Mipedian Dew Farm__ss"
  },
  {
    "id": "97/100",
    "name": "Mipedim Lounge",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "ability": "Mirage: When an Attack Card is played by a Creature in this space, its controller can flip a coin. If tails, that player sacrifices his engaged Creature. If heads, the attack deals an additional 10 damage, and that player can flip again.",
    "flavorText": "",
    "unique": false,
    "initiative": "Invisibility",
    "type": "Mirage",
    "artist": "Keith Conroy, Anthony Washington",
    "imageUrl": "https://i.imgur.com/6JsJrX7.png",
    "uniqueId": "Mipedim Lounge__ss"
  },
  {
    "id": "98/100",
    "name": "Mipedim Mirage",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "ability": "Creatures have \"Swift 1.\"\r\nMirage: If an adjacent Creature can move into this space, it must do so.",
    "flavorText": "No one believed what the Muges saw, except for Tiaane.",
    "unique": false,
    "initiative": "Danian",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/g6pofj6.png",
    "uniqueId": "Mipedim Mirage__ss"
  },
  {
    "id": "99/100",
    "name": "OverWorld Embassy at Mipedim Oasis",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "ability": "When this becomes the active Location, shuffle any Mirage Locations on the Battleboard into their controllers' Location Decks. \r\nMipedian Creatures have :water:Water.",
    "flavorText": "Its outward tranquility masks the tumult within.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/iUHlJ6p.png",
    "uniqueId": "OverWorld Embassy at Mipedim Oasis__ss"
  },
  {
    "id": "100/100",
    "name": "Rao'Pa Sahkk",
    "subname": "The Ocean with No Water",
    "set": "ss",
    "rarity": "common",
    "ability": "Attacks that are either :air:Air or :earth:Earth deal an additional 5 damage. (Attacks which are both :air:Air and :earth:Earth deal only 5 additional damage.)\r\nWhen a :water:Water attack is played, that attack's controller reveals a new active Location.\r\nMirage: When combat ends, put a :genericmugic: on Creatures in this space who were engaged.",
    "flavorText": "",
    "unique": false,
    "initiative": "Fire",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ZjxQ5Bg.png",
    "uniqueId": "Rao'Pa Sahkk__ss"
  },
  {
    "id": "93/100",
    "name": "The Hunter's Perimeter",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "ability": "When this becomes the active Location, Mipedian Creatures gain \"Invisibility: Surprise.\"\r\nAt the beginning of combat, reveal a new active Location.\r\nMirage: Creatures in this space cannot lose Invisibility from Mugic or abilities. Invisibility abilities of Creatures in this space work against Creatures with Invisibility.",
    "flavorText": "",
    "unique": false,
    "initiative": "Speed",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/oytQf97.png",
    "uniqueId": "The Hunter's Perimeter__ss"
  },
  {
    "id": "195/222",
    "name": "Bodal's Arsenal",
    "subname": "",
    "set": "btd",
    "rarity": "ultra rare",
    "ability": "When this becomes the active Location, each player can return a Battlegear Card from their general discard pile to play equipped to an unequipped Creature that player controls.",
    "flavorText": "",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/cBXztYA.png",
    "uniqueId": "Bodal's Arsenal__btd"
  },
  {
    "id": "196/222",
    "name": "Brawlers' Burrow",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "ability": "When this becomes the active Location, both players shuffle their Attack Decks and attack discard piles together.\r\nAll Creatures have \"Outperform all Disciplines 5.\"",
    "flavorText": "",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/LAUcPQE.png",
    "uniqueId": "Brawlers' Burrow__btd"
  },
  {
    "id": "197/222",
    "name": "Broken Edge",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Engaged Creatures have \"Outperform :speed:Speed 5.\" \r\nDamage dealt by :wisdom:Wisdom Attacks is reduced by 5.",
    "flavorText": "Nature wages its own war between the forest and the desert.",
    "unique": false,
    "initiative": "Air",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/oJ5XuaD.png",
    "uniqueId": "Broken Edge__btd"
  },
  {
    "id": "198/222",
    "name": "Chamber of Waves",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "ability": "Creatures have 10 less in all Disciplines.",
    "flavorText": "As corrupted water flows through the pipes of the gigantic acoustic organ, a sound resonates that is both eerie, beautiful and inexplicably dangerous.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/8RFTDrR.png",
    "uniqueId": "Chamber of Waves__btd"
  },
  {
    "id": "199/222",
    "name": "Deadrange Gong",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Chieftain Creatures have an additional 15 in all Disciplines and \":water:Water 5.\"",
    "flavorText": "Reverberating throughout the deep, M'arrillians can also receive commands by sensing vibrations in the water.",
    "unique": false,
    "initiative": "Fire",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/JbXi5CK.png",
    "uniqueId": "Deadrange Gong__btd"
  },
  {
    "id": "200/222",
    "name": "Gambreor's Hut",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Creatures you control have \"Fireproof 5.\" \r\nIf a Creature's Discipline would decrease, that Discipline decreases by 10 less instead.",
    "flavorText": "",
    "unique": true,
    "initiative": "Power",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ijQXKND.png",
    "uniqueId": "Gambreor's Hut__btd"
  },
  {
    "id": "201/222",
    "name": "Gloom-mire Night",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "ability": "Creatures cannot be relocated by Mugic, abilities or Attacks.",
    "flavorText": "As Bodal sank into the murky swamp, he calculated that he had 45.7 seconds until he would be gargling black ooze.",
    "unique": false,
    "initiative": "Mipedian",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/QsIpL9t.png",
    "uniqueId": "Gloom-mire Night__btd"
  },
  {
    "id": "202/222",
    "name": "Hall of Fatigue",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "ability": "Engaged Creatures have \"Exhaust :power:Power 5\" and \"Exhaust :speed:Speed 5.\"",
    "flavorText": "When the body has nothing left to give, only the strong-willed fight on.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/NC5uVIy.png",
    "uniqueId": "Hall of Fatigue__btd"
  },
  {
    "id": "205/222",
    "name": "Ijahni Outpost",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Your Creatures have 10 less Energy. \r\nMirage: Creatures cannot move off this space unless their controller removes a :genericmugic: from any Creature they control.",
    "flavorText": "",
    "unique": false,
    "initiative": "Air",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/VLLQDhw.png",
    "uniqueId": "Ijahni Outpost__btd"
  },
  {
    "id": "206/222",
    "name": "Illusionary Lake",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Engaged Creatures do not have :water:Water and cannot gain it.\r\nMirage: Creatures in this space do not have :water:Water and cannot gain it.",
    "flavorText": "",
    "unique": false,
    "initiative": "Water",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Xx8m6iz.png",
    "uniqueId": "Illusionary Lake__btd"
  },
  {
    "id": "207/222",
    "name": "Imaginary Walls",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "ability": "When this becomes the active Location, your opponent can return a Mugic Card in their general discard pile to their hand.\r\nAttacks deal 10 less damage to Creatures that are a M'arrillian or a Minion.",
    "flavorText": "",
    "unique": true,
    "initiative": "Danian",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/qgK5Oef.png",
    "uniqueId": "Imaginary Walls__btd"
  },
  {
    "id": "209/222",
    "name": "Jade Pillar",
    "subname": "",
    "set": "btd",
    "rarity": "ultra rare",
    "ability": "When this becomes the active Location, put 10 Jade counters on it. As an attack deals damage, remove 1 Jade Counter for each 5 damage dealt.\r\nWhen the last Counter is removed, Jade Pillar deals 50 damage to the Creature that played the last attack.",
    "flavorText": "",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Jim Manoccio, Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/TYCTk3i.png",
    "uniqueId": "Jade Pillar__btd"
  },
  {
    "id": "210/222",
    "name": "Lava Pond",
    "subname": "Milla'iin's Foothold",
    "set": "btd",
    "rarity": "rare",
    "ability": "When this becomes the active Location, each player reveals a random Mugic Card from their hand.\r\nCards with the same name as the revealed cards cannot be played.\r\nCreatures that are a M'arrillian or a Minion take 5 less non-attack damage.",
    "flavorText": "",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel, HotShots VFX",
    "imageUrl": "https://i.imgur.com/oKOfIV5.png",
    "uniqueId": "Lava Pond__btd"
  },
  {
    "id": "211/222",
    "name": "Mommark's Catapult Tower",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "ability": "When this becomes the active Location, Creatures you control gain \"Swift 1.\"",
    "flavorText": "",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/4OK0Z5o.png",
    "uniqueId": "Mommark's Catapult Tower__btd"
  },
  {
    "id": "212/222",
    "name": "Mount Pillar Reservoir",
    "subname": "Neth'uar's Foothold",
    "set": "btd",
    "rarity": "rare",
    "ability": "When this becomes the active Location, each player can return a Chieftain Creature Card from their general discard pile to play to any unoccupied space on their side of the Battleboard. \r\nCreatures that are a M'arrillian or a Minion have \":water:Water 5.\"",
    "flavorText": "",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Kk5myn0.png",
    "uniqueId": "Mount Pillar Reservoir__btd"
  },
  {
    "id": "213/222",
    "name": "Open Doors of the Deepmines",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Minion Creatures are treated as if their controller also controlled a Chieftain.",
    "flavorText": "\"Prepare yourselves! This is the nightmare I foretold!\" — Najarin",
    "unique": true,
    "initiative": "Minion",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/g4ioY8N.png",
    "uniqueId": "Open Doors of the Deepmines__btd"
  },
  {
    "id": "216/222",
    "name": "Psikoom Madness Chamber",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "ability": "Engaged Creatures have \"Exhaust :courage:Courage 5\" and \"Exhaust :wisdom:Wisdom 5.\"",
    "flavorText": "The lucky ones go insane.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/OcimSfF.png",
    "uniqueId": "Psikoom Madness Chamber__btd"
  },
  {
    "id": "217/222",
    "name": "Rao'Pa Sahkk",
    "subname": "Ihun'kalin's Foothold",
    "set": "btd",
    "rarity": "rare",
    "ability": "When this becomes the active Location, each player sacrifices a Battlegear. \r\nWhen a M'arrillian or Minion Creature wins a Challenge on an Attack it plays, that Creature gains 5 Energy.",
    "flavorText": "",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Khary Randolph, Emilio Lopez, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/huKbWGM.png",
    "uniqueId": "Rao'Pa Sahkk__btd"
  },
  {
    "id": "218/222",
    "name": "Riverlands",
    "subname": "Erak'tabb's Foothold",
    "set": "btd",
    "rarity": "rare",
    "ability": "When this becomes the active Location, each player removes a :genericmugic: from a Creature they control.\r\nAttacks deal 5 less damage to Creatures that are a M'arrillian or a Minion.",
    "flavorText": "",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Keith Conroy, David Curiel, HotShots VFX",
    "imageUrl": "https://i.imgur.com/ZxUqjNB.png",
    "uniqueId": "Riverlands__btd"
  },
  {
    "id": "219/222",
    "name": "Stormgrounds",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Minion Creatures' activated abilities cost an additional :genericmugic: to play.",
    "flavorText": "The lightning storm has raged for hundreds of years... and will continue to do so long after every Creature is gone.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/rcFs02y.png",
    "uniqueId": "Stormgrounds__btd"
  },
  {
    "id": "203/222",
    "name": "The Heart of the Jungle",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "When one engaged Creature increases or decreases a Discipline except from this ability, increases or decreases that Discipline of the other engaged Creature by the same amount. \r\nMirage: Creatures in this space have an additional 10 in all Disciplines.",
    "flavorText": "",
    "unique": true,
    "initiative": "OverWorld",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/tzP4oby.png",
    "uniqueId": "The Heart of the Jungle__btd"
  },
  {
    "id": "204/222",
    "name": "The Hive Gallery",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Engaged Creatures have \"Outperform :courage:Courage 5.\" \r\nDamage dealt by :power:Power Attacks is reduced by 5.",
    "flavorText": "As long as we never forget the fallen, they will live forever.",
    "unique": false,
    "initiative": "Earth",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/YbDf6Wq.png",
    "uniqueId": "The Hive Gallery__btd"
  },
  {
    "id": "208/222",
    "name": "The Infectorium",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "ability": "At the beginning of combat, deal 15 damage to Infected engaged non-Danian Creatures.",
    "flavorText": "As the breeding ground of millions of parasites, Danians can infect every Creature in Perim a hundred times over.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/SYNPkCw.png",
    "uniqueId": "The Infectorium__btd"
  },
  {
    "id": "214/222",
    "name": "The OverWorld Library",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Engaged Creatures have \"Outperform :wisdom:Wisdom 5.\" \r\nDamage dealt by :courage:Courage Attacks is reduced by 5.",
    "flavorText": "From cookbooks to Cothica clues, every book written is within.",
    "unique": false,
    "initiative": "Water",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ymY9TCG.png",
    "uniqueId": "The OverWorld Library__btd"
  },
  {
    "id": "215/222",
    "name": "The Pits",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "Engaged Creatures have \"Outperform :power:Power 5.\" \r\nDamage dealt by :speed:Speed Attacks is reduced by 5.",
    "flavorText": "The UnderWorlders are fair - all are guilty until proven innocent.",
    "unique": false,
    "initiative": "Fire",
    "type": "",
    "artist": "Keith Conroy, Anthony Washington",
    "imageUrl": "https://i.imgur.com/fPXFtpL.png",
    "uniqueId": "The Pits__btd"
  },
  {
    "id": "220/222",
    "name": "Ulmar's Projection Cavern",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "When this becomes the active Location, your opponent reveals a new active Location. \r\nMirage: At the beginning of each player's turn, if this space is unoccupied, that player can relocate one of their Creatures to this space on the Battleboard.",
    "flavorText": "",
    "unique": true,
    "initiative": "Water",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/LXMjjLN.png",
    "uniqueId": "Ulmar's Projection Cavern__btd"
  },
  {
    "id": "221/222",
    "name": "Van Bloot's Banquet",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "ability": "Creatures that are a M'arrillian or a Minion have an additional 5 Energy. \r\nWhen your engaged Creature loses Initiative, it gains 20 to all Disciplines.",
    "flavorText": "A toast to my new friends! Together, we'll overthrow Chaor!",
    "unique": false,
    "initiative": "UnderWorld",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/pJP4zA0.png",
    "uniqueId": "Van Bloot's Banquet__btd"
  },
  {
    "id": "222/222",
    "name": "Vidav's Refectorium",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "ability": "When this becomes the active Location, each player draws two Attack Cards, then discards two Attack Cards.",
    "flavorText": "Though Vidav wants peace, his battle tactics are undeniably the best.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/fMLjVL6.png",
    "uniqueId": "Vidav's Refectorium__btd"
  },
  {
    "id": "91/100",
    "name": "Frozen Fire",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "ability": "When a Creature has a Mugic counter put on it or removed from it, deal 5 damage to it.",
    "flavorText": "The ocean of flames chills as it burns.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/2mqd2ag.png",
    "uniqueId": "Frozen Fire__roto"
  },
  {
    "id": "92/100",
    "name": "Kiru City Tunnels",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "ability": "Creatures with 35 or more Scanned Energy deal 10 less attack damage.\r\nWhen any player shuffles their Attack Deck, that player reveals a new active Location.",
    "flavorText": "",
    "unique": false,
    "initiative": "Muge",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/OoDusKp.png",
    "uniqueId": "Kiru City Tunnels__roto"
  },
  {
    "id": "93/100",
    "name": "Psi-fanger's Shelf",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "ability": "If a player would draw and play an Attack, they return an Attack from their Attack Discard pile to their hand and play an Attack instead. If an Attack played this way would go to the discard pile, place it on the bottom of its owner's Attack Deck instead.\r\nIf any Attack Discard pile is empty, reveal a new active location.",
    "flavorText": "",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/PyhRPPr.png",
    "uniqueId": "Psi-fanger's Shelf__roto"
  },
  {
    "id": "94/100",
    "name": "Royal Mipedian Academy of Melee Arts",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "ability": "Non-attack damage is reduced to 0. \r\nMirage: Creatures in this space cannot be targeted by Mugic.",
    "flavorText": "Trust not blades, for they break. Trust not shields, for they shatter. Trust only yourself, who can neither break nor shatter.",
    "unique": false,
    "initiative": "Speed",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/8RPHJlr.png",
    "uniqueId": "Royal Mipedian Academy of Melee Arts__roto"
  },
  {
    "id": "95/100",
    "name": "Siril'ean's Lair",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "ability": "At the beginning of combat, if a player has fewer Mugic Cards in hand than the number of Creatures they control, that player discards a Mugic Card.",
    "flavorText": "",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/kCEMcwE.png",
    "uniqueId": "Siril'ean's Lair__roto"
  },
  {
    "id": "96/100",
    "name": "Skeletal Springs",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "ability": "Creatures with :water:Water have \":water:Water 5.\" \r\nFluidmorpher Creatures cannot have Mugic counters put on them or use Mugic counters to pay for Mugic or abilities.",
    "flavorText": "",
    "unique": false,
    "initiative": "OverWorld",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/VPnZNw8.png",
    "uniqueId": "Skeletal Springs__roto"
  },
  {
    "id": "97/100",
    "name": "The Coralsmithy",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "ability": "When an attack that has both :fire:Fire and :water:Water is played by a Creature, its controller can swap one of that Creature's Battlegear with a Battlegear Card in its controller's general discard pile.",
    "flavorText": "",
    "unique": false,
    "initiative": "Fire",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Rl9z3rm.png",
    "uniqueId": "The Coralsmithy__roto"
  },
  {
    "id": "98/100",
    "name": "The Oligarch's Path",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "ability": "Chieftain Creatures have an additional 10 Energy.\r\nCreatures pay 4 less Mugic counters to play Mugic named Calling of Aa'une.",
    "flavorText": "Najarin's visions were getting more disturbing. How could the worst be still to come?!?",
    "unique": false,
    "initiative": "Chieftain",
    "type": "",
    "artist": "Robert Dizon",
    "imageUrl": "https://i.imgur.com/vTGn9pq.png",
    "uniqueId": "The Oligarch's Path__roto"
  },
  {
    "id": "99/100",
    "name": "The Rao'Pa Sahkk Chimegrid",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "ability": "When this becomes the active Location, each player puts a :genericmugic: on a Creature they control.",
    "flavorText": "The sound reverberated far and wide - the Song of Doom!",
    "unique": false,
    "initiative": "Mugic counters",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Ddy2YfL.png",
    "uniqueId": "The Rao'Pa Sahkk Chimegrid__roto"
  },
  {
    "id": "100/100",
    "name": "The Training Grounds",
    "subname": "",
    "set": "roto",
    "rarity": "ultra rare",
    "ability": "At the beginning of combat, deal 5 damage to each engaged Creature for each Mugic counter on that Creature.\r\nWhen a Creature wins combat, put Mugic counters on that Creature equal to its Mugic Ability.",
    "flavorText": "",
    "unique": false,
    "initiative": "Mugic Ability",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/rxAsQjj.png",
    "uniqueId": "The Training Grounds__roto"
  },
  {
    "id": "91/100",
    "name": "Brawlers' Burrow",
    "subname": "Pugilist's Pit",
    "set": "tott",
    "rarity": "common",
    "ability": "Engaged Creatures have \"Disarm.\"",
    "flavorText": "Unfortunately for Solvis, eye gouging is still legal.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/9JgLBk4.png",
    "uniqueId": "Brawlers' Burrow__tott"
  },
  {
    "id": "92/100",
    "name": "Foothold Assault Trench",
    "subname": "",
    "set": "tott",
    "rarity": "super rare",
    "ability": "If all Creatures a player controls share a Tribe, that player's engaged Creature deals an additional 5 attack damage.",
    "flavorText": "",
    "unique": true,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/UrM8j6e.png",
    "uniqueId": "Foothold Assault Trench__tott"
  },
  {
    "id": "93/100",
    "name": "Glacier Plains",
    "subname": "M'arrillian Melting Camp",
    "set": "tott",
    "rarity": "super rare",
    "ability": "At the beginning of combat, each player can remove two Mugic counters from any Creatures they control. If a player does not, their engaged Creature loses 50 in each Discipline.",
    "flavorText": "",
    "unique": false,
    "initiative": "Fluidmorpher",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/mpBXWl7.png",
    "uniqueId": "Glacier Plains__tott"
  },
  {
    "id": "94/100",
    "name": "Lore's Chamber of Recall",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "ability": "When this becomes the active Location, remove all cards in each general discard pile from the game.\r\nMirage: At the beginning of combat, engaged Creatures in this space with 30 or less Scanned Energy gain 30 Energy.",
    "flavorText": "",
    "unique": false,
    "initiative": "Power",
    "type": "Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/KuWBRm4.png",
    "uniqueId": "Lore's Chamber of Recall__tott"
  },
  {
    "id": "95/100",
    "name": "Pouril Forest",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "ability": "Creatures do not have and cannot gain Defender.",
    "flavorText": "The most peaceful place in Perim... until Yokkis shows up and slaps a pie in your face!",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ej5pQwv.png",
    "uniqueId": "Pouril Forest__tott"
  },
  {
    "id": "96/100",
    "name": "Prototype Demolition Field",
    "subname": "",
    "set": "tott",
    "rarity": "super rare",
    "ability": "When a Creature deals 20 or more damage with its first attack each combat, destroy all Battlegear equipped to it.",
    "flavorText": "Finish first? I'm more worried about finishing in one piece!",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/Zz5FgPT.png",
    "uniqueId": "Prototype Demolition Field__tott"
  },
  {
    "id": "97/100",
    "name": "Shardcrafters' Workshop",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "ability": "Shard Battlegear have \"Equipped Creature deals an additional 5 attack damage.\" \r\nBattlegear cannot be flipped face-down.",
    "flavorText": "Kha'rall are nearly unstoppable. The shards guarantee that they are.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/7d3JzwT.png",
    "uniqueId": "Shardcrafters' Workshop__tott"
  },
  {
    "id": "98/100",
    "name": "The Phalanx Portcullis",
    "subname": "",
    "set": "tott",
    "rarity": "uncommon",
    "ability": "Creatures with less than 50 :courage:Courage deal 5 less attack damage.\r\nCreatures with more than 100 :courage:Courage deal an additional 5 attack damage.",
    "flavorText": "",
    "unique": false,
    "initiative": "Scanned Energy",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/4x4IEXB.png",
    "uniqueId": "The Phalanx Portcullis__tott"
  },
  {
    "id": "99/100",
    "name": "The Storm Tunnel",
    "subname": "Flooding",
    "set": "tott",
    "rarity": "common",
    "ability": "Engaged Creatures have \":water:Water 5.\"\r\nCreatures with :air:Air that became engaged this turn have an additional 10 Energy.",
    "flavorText": "The air drowns, the sky cries, the winds cease, the hope dies.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/qRdg2E3.png",
    "uniqueId": "The Storm Tunnel__tott"
  },
  {
    "id": "100/100",
    "name": "UnderWorld City",
    "subname": "During Van Bloot's Ascent",
    "set": "tott",
    "rarity": "uncommon",
    "ability": "Creatures not named Lord Van Bloot have 10 less :courage:Courage.\r\nAttack Cards played by Minion Creatures have \"Challenge :courage:Courage 15: Deal 5 damage.\"",
    "flavorText": "",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Khary Randolph, Chris Fisher",
    "imageUrl": "https://i.imgur.com/RoLrWm3.png",
    "uniqueId": "UnderWorld City__tott"
  },
  {
    "id": "89/100",
    "name": "Carnival of Confusion",
    "subname": "Mind Games",
    "set": "fun",
    "rarity": "rare",
    "ability": "When a player would draw and play an Attack Card, instead they reveal and play the top card of their Attack Deck.",
    "flavorText": "If I say I'm lying, am I telling the truth?",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Andrew Bradshaw, Reggie Butler, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/sA09HZ7.png",
    "uniqueId": "Carnival of Confusion__fun"
  },
  {
    "id": "90/100",
    "name": "Cryomorph Barricades",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "ability": "Creatures with Defender deal an additional 5 attack damage. \r\nMirage: Creatures in this space have \"Defender.\"",
    "flavorText": "Even Intress was flabbergasted that the Fluidmorphers built the wall in a day.",
    "unique": false,
    "initiative": "Power",
    "type": "Mirage",
    "artist": "Chris Fisher, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/qcUCrtk.png",
    "uniqueId": "Cryomorph Barricades__fun"
  },
  {
    "id": "91/100",
    "name": "Glacier Plains",
    "subname": "M'arrillian Heat Cannon",
    "set": "fun",
    "rarity": "ultra rare",
    "ability": "Remove 50 Mugic counters from among Creatures you control: Win the game. Any player can play this ability.",
    "flavorText": "\"If the ice melts, Perim will die. We must stop it... no matter what the sacrifice.\" — Tangath Toborn",
    "unique": true,
    "initiative": "Mugic counters",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/3vOnBAs.png",
    "uniqueId": "Glacier Plains__fun"
  },
  {
    "id": "92/100",
    "name": "Gorram's Briefing",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "ability": "At the beginning of combat, engaged Creatures gains 5 Energy and 5 to all Disciplines for each Tribe its controller controls.",
    "flavorText": "The beginning of the end begins.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/Qja046l.png",
    "uniqueId": "Gorram's Briefing__fun"
  },
  {
    "id": "93/100",
    "name": "Lake Blakeer",
    "subname": "",
    "set": "fun",
    "rarity": "super rare",
    "ability": "At the beginning of combat, engaged M'arrillian Creatures lose 10 Energy. engaged M'arrillian Creatures named Aa'une gain 20 Energy instead.",
    "flavorText": "The legend forged here will last for generations.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/op2y85s.png",
    "uniqueId": "Lake Blakeer__fun"
  },
  {
    "id": "94/100",
    "name": "Lake Morn",
    "subname": "Globe Storm",
    "set": "fun",
    "rarity": "common",
    "ability": "When this becomes the active Location, flip a coin. If heads, Creatures with :water:Water take an additional 5 attack damage. If tails, Creatures with :water:Water take 5 less attack damage.",
    "flavorText": "",
    "unique": false,
    "initiative": "Air",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/nLY7A04.png",
    "uniqueId": "Lake Morn__fun"
  },
  {
    "id": "95/100",
    "name": "M'arrillian Pulse Beacons",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "ability": "When this becomes the active Location, flip all face-up Battlegear face-down.",
    "flavorText": "The M'arrillians need not be present to make their presence felt.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/6ztxliR.png",
    "uniqueId": "M'arrillian Pulse Beacons__fun"
  },
  {
    "id": "96/100",
    "name": "Numin Voidland",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "ability": "At the beginning of combat, engaged Creatures lose all Elemental Types and gain 10 Energy for each Elemental Type lost this way.",
    "flavorText": "Nothing survives here, not even the M'arrillians themselves!",
    "unique": false,
    "initiative": "Scanned Energy",
    "type": "",
    "artist": "Keith Conroy, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/E8vKeFT.png",
    "uniqueId": "Numin Voidland__fun"
  },
  {
    "id": "97/100",
    "name": "Pyrogenousist's Hearth",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "ability": "At the beginning of combat, deal 10 damage to each engaged Creature with no Mugic counters on them.",
    "flavorText": "",
    "unique": false,
    "initiative": "Fire",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/jY6uZXK.png",
    "uniqueId": "Pyrogenousist's Hearth__fun"
  },
  {
    "id": "98/100",
    "name": "Quarters of the Quartet",
    "subname": "",
    "set": "fun",
    "rarity": "super rare",
    "ability": "While a player controls exactly four Tribes, that player's Creatures have \"Untargetable by opponents.\"",
    "flavorText": "Four minds, one heart, Perim forever.",
    "unique": false,
    "initiative": "Mugic counters",
    "type": "",
    "artist": "Keith Conroy, Reggie Butler",
    "imageUrl": "https://i.imgur.com/Xjh691R.png",
    "uniqueId": "Quarters of the Quartet__fun"
  },
  {
    "id": "99/100",
    "name": "The Northrange",
    "subname": "Highground",
    "set": "fun",
    "rarity": "rare",
    "ability": "When this becomes the active Location, choose a Tribe. All Creatures also count as that Tribe. \r\nMirage: Creatures in this space count as all Tribes.",
    "flavorText": "",
    "unique": false,
    "initiative": "Courage",
    "type": "Mirage",
    "artist": "Adrian Barrios. Anthony Washington",
    "imageUrl": "https://i.imgur.com/kfFP5I7.png",
    "uniqueId": "The Northrange__fun"
  },
  {
    "id": "100/100",
    "name": "The Storm Tunnel",
    "subname": "Ki'bro's Foothold",
    "set": "fun",
    "rarity": "common",
    "ability": "All attacks also count as :water:Water attacks. \r\nDamage dealt by :air:Air attacks is reduced by 5.",
    "flavorText": "Fighting the war on many fronts stretches even the M'arrillians to their limits.",
    "unique": false,
    "initiative": "Water",
    "type": "",
    "artist": "Emilio Lopez, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/0C1lu7F.png",
    "uniqueId": "The Storm Tunnel__fun"
  },
  {
    "id": "175/200",
    "name": "AZAIA Mindscrying Chamber",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "ability": "When this becomes the active Location, Creatures lose all Elemental Types.",
    "flavorText": "Your most private secrets may be locked in the deepest recesses of your mind... but we hold the key.",
    "unique": false,
    "initiative": "M'arrillian",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/E9qxZAi.png",
    "uniqueId": "AZAIA Mindscrying Chamber__au"
  },
  {
    "id": "176/200",
    "name": "Castle Mommark",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "ability": "When this becomes the active Location, each player can sacrifice a Creature they control. If they do, they can return another Creature Card from their general discard pile to play to any unoccupied space on their side of the Battleboard.",
    "flavorText": "",
    "unique": false,
    "initiative": "Fire",
    "type": "",
    "artist": "Keith Conory, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/KP8bfI3.png",
    "uniqueId": "Castle Mommark__au"
  },
  {
    "id": "177/200",
    "name": "Castle Rathwaq",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "ability": "The engaged Creature with the lowest :power:Power deals 5 less damage with attacks.",
    "flavorText": "Grotesquely beautiful, the design is as twisted as its inhabitants.",
    "unique": false,
    "initiative": "Earth",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/wcPjD9D.png",
    "uniqueId": "Castle Rathwaq__au"
  },
  {
    "id": "178/200",
    "name": "City of Kehn-sep",
    "subname": "Tablet Dig Site",
    "set": "au",
    "rarity": "rare",
    "ability": "At the beginning of combat, each player reveals the top 2 cards of their Attack Deck. Any player who reveals 3 or more total Build Points in Attack Cards puts :genericmugic::genericmugic: on their engaged Creature. Put the revealed cards on the bottom of the Attack Deck in any order.",
    "flavorText": "",
    "unique": false,
    "initiative": "Mipedian",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/BMeKc9T.png",
    "uniqueId": "City of Kehn-sep__au"
  },
  {
    "id": "S20/26",
    "name": "Dranakis Threshold",
    "subname": "Portal to the Past",
    "set": "au",
    "rarity": "super rare",
    "ability": "Creatures are considered Past Creatures.\r\nCreatures have no Tribes.",
    "flavorText": "The past, present and future all converge here.",
    "unique": false,
    "initiative": "Speed",
    "type": "Past",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/NGj9Qbw.png",
    "uniqueId": "Dranakis Threshold__au"
  },
  {
    "id": "180/200",
    "name": "Elmantiir",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "ability": "At the beginning of combat, engaged Creatures gain 5 Energy for each Elemental Type they have.",
    "flavorText": "As the Elmantiir manifested, Intress knew that she would win - the Emperors of the Elements had bestowed their might upon her.",
    "unique": false,
    "initiative": "Elementalist",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/EBakrrO.png",
    "uniqueId": "Elmantiir__au"
  },
  {
    "id": "S21/26",
    "name": "Gigantempopolis",
    "subname": "Chamber of the Oraklon",
    "set": "au",
    "rarity": "rare",
    "ability": "Each Battlegear has \"Untargetable.\"",
    "flavorText": "Since the Oraklon allows one to peer into distant lands, it is no wonder the giants guarded it so closely... or that Vlar wanted it so badly!",
    "unique": false,
    "initiative": "Water",
    "type": "Past",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/yeJTTMi.png",
    "uniqueId": "Gigantempopolis__au"
  },
  {
    "id": "S22/26",
    "name": "Graalorn Forest",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "When an Elemental Attack is played by a Creature, heal 5 damage to it.",
    "flavorText": "The heart of the forest exhales, breathing life into those injured.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "Past",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/LqrnDTF.png",
    "uniqueId": "Graalorn Forest__au"
  },
  {
    "id": "183/200",
    "name": "Herken's Feast",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "The first attack played by a Creature each combat is reduced by 20 damage.",
    "flavorText": "The sumptuous meal would have thrilled royalty, but the guests had more important matters to digest.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Andrew Bradshaw, Keith Conroy, Bob Rivard",
    "imageUrl": "https://i.imgur.com/Mte6gHq.png",
    "uniqueId": "Herken's Feast__au"
  },
  {
    "id": "184/200",
    "name": "Kaizeph",
    "subname": "City of the Elements",
    "set": "au",
    "rarity": "super rare",
    "ability": "Creatures take 5 less damage from attacks they share an Elemental Type with.",
    "flavorText": "Unlike all else, the Citadel is the foundation of everything.",
    "unique": false,
    "initiative": "Number of Elements",
    "type": "",
    "artist": "Keith Conroy, Anthony Washington",
    "imageUrl": "https://i.imgur.com/gxClBHF.png",
    "uniqueId": "Kaizeph__au"
  },
  {
    "id": "S23/26",
    "name": "Kiru Village",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "Past Creatures have an additional 10 Energy.",
    "flavorText": "\"Yes, Chaor's ancestor was one of the greatest OverWorlders of all time. I'm proud he was my friend, despite what he ultimately became.\" — Najarin",
    "unique": false,
    "initiative": "Air",
    "type": "Past",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/bTneN5w.png",
    "uniqueId": "Kiru Village__au"
  },
  {
    "id": "185/200",
    "name": "Lake Ken-I-Po",
    "subname": "Ritual Site",
    "set": "au",
    "rarity": "rare",
    "ability": "Creatures cannot gain or lose Elemental Types from Mugic, Attacks or abilities.",
    "flavorText": "As the towers emerged, all wondered what more lay bellow the surface.",
    "unique": false,
    "initiative": "Number of Elements",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/eTKm4UP.png",
    "uniqueId": "Lake Ken-I-Po__au"
  },
  {
    "id": "S24/26",
    "name": "Mipedim Tropics",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "Mipedian Creatures have :water:Water and \":water:Water 5.\"",
    "flavorText": "Though widely dismissed as anomalies, the first minuscule desert patches were signs that paradise was not forever.",
    "unique": false,
    "initiative": "Courage",
    "type": "Past",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/dTqTZj5.png",
    "uniqueId": "Mipedim Tropics__au"
  },
  {
    "id": "187/200",
    "name": "Mipedim Valley",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "Battlegear equipped to Creatures without :air:Air is not flipped face-up at the beginning of combat.",
    "flavorText": "Some Mipedians yearn for a home from the unforgiving desert. And they may have just found it.",
    "unique": false,
    "initiative": "Water",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/mbRIHJe.png",
    "uniqueId": "Mipedim Valley__au"
  },
  {
    "id": "188/200",
    "name": "Mount Pillar Reservoir",
    "subname": "Liberated",
    "set": "au",
    "rarity": "rare",
    "ability": "When this becomes the active Location, each player Infects an Uninfected Creature they control.",
    "flavorText": "The Danians' lifeblood is also the root of the Mipedians' hatred.",
    "unique": false,
    "initiative": "Danian",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/aXn1Ihf.png",
    "uniqueId": "Mount Pillar Reservoir__au"
  },
  {
    "id": "189/200",
    "name": "Najarin's Castle",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "ability": "When this becomes the active Location, each player can discard a Mugic Card. If they do, they can return a Mugic Card from their general discard pile to their hand.",
    "flavorText": "",
    "unique": false,
    "initiative": "Mugic counters",
    "type": "",
    "artist": "Keith Conroy, Anthony Washington",
    "imageUrl": "https://i.imgur.com/Xqp4oRS.png",
    "uniqueId": "Najarin's Castle__au"
  },
  {
    "id": "S25/26",
    "name": "Prexxor Chasm",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "ability": "At the beginning of the turn, choose a Creature your opponent controls and they choose a Creature you control. Relocate your Creature into the opposing Creature's space and begin combat. This does not count toward your one combat per turn.",
    "flavorText": "",
    "unique": false,
    "initiative": "Past",
    "type": "Past",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/OZMeeph.png",
    "uniqueId": "Prexxor Chasm__au"
  },
  {
    "id": "S26/26",
    "name": "Prexxor Chasm",
    "subname": "The Blight",
    "set": "au",
    "rarity": "ultra rare",
    "ability": "Non-Caretaker Creatures cannot be healed or gain Energy from non-innate abilities.\r\nMirage: Creatures in this space have 20 less Energy.",
    "flavorText": "Forever insatiable, The Blight consumes all.",
    "unique": false,
    "initiative": "Power",
    "type": "Past Mirage",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/ZtU0icW.png",
    "uniqueId": "Prexxor Chasm__au"
  },
  {
    "id": "193/200",
    "name": "Rao'Pa Sahkk",
    "subname": "Condensation Ceremony",
    "set": "au",
    "rarity": "super rare",
    "ability": "Creatures without :water:Water cannot spend Mugic counters to play Mugic or abilities.",
    "flavorText": "Fluidmorphers can manipulate all water, from vast oceans to individual droplets of vapor.",
    "unique": false,
    "initiative": "Earth",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/nP6rdvo.png",
    "uniqueId": "Rao'Pa Sahkk__au"
  },
  {
    "id": "194/200",
    "name": "Riverlands",
    "subname": "Abandoned Wastes",
    "set": "au",
    "rarity": "common",
    "ability": "When this becomes the active Location, each player shuffles their attack hand into their Attack Deck and draws two Attack Cards.",
    "flavorText": "",
    "unique": false,
    "initiative": "Fewest Elements",
    "type": "",
    "artist": "Keith Conroy, Emilio Lopez, HotShotsVFX",
    "imageUrl": "https://i.imgur.com/en68Sqw.png",
    "uniqueId": "Riverlands__au"
  },
  {
    "id": "195/200",
    "name": "Rock River Canyon",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "ability": "Creatures with :earth:Earth have an additional 10 Energy.",
    "flavorText": "A metaphor for patience: just one tiny stream carved the land into a canyon over the course of a thousand generations.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/uqW1kaI.png",
    "uniqueId": "Rock River Canyon__au"
  },
  {
    "id": "196/200",
    "name": "Star Towers of Kehn-sep",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "ability": "At the beginning of combat, if an engaged Creature has higher :wisdom:Wisdom than the opposing engaged Creature, that Creature's controller can remove a :genericmugic: from a Creature they control. If they do, they can put a :genericmugic: on a Creature they control.",
    "flavorText": "",
    "unique": false,
    "initiative": "Air",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/x68amyh.png",
    "uniqueId": "Star Towers of Kehn-sep__au"
  },
  {
    "id": "200/200",
    "name": "Tablet Sanctuary",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "ability": "At the beginning of combat, put a :genericmugic: on the engaged Creature with the most Elemental types.",
    "flavorText": "Though the tablet answered many long-debated questions, not every Creature liked the answers.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/oqKYsCz.png",
    "uniqueId": "Tablet Sanctuary__au"
  },
  {
    "id": "179/200",
    "name": "The Cliffs",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "At the beginning of combat, all Creatures gain :earth:Earth.",
    "flavorText": "No matter how hard they tried, the Danians could not win the staring contest.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/fDFNP2L.png",
    "uniqueId": "The Cliffs__au"
  },
  {
    "id": "181/200",
    "name": "The Garden",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "At the beginning of combat, all Creatures gain :water:Water.",
    "flavorText": "Water is life.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/WvzABfl.png",
    "uniqueId": "The Garden__au"
  },
  {
    "id": "182/200",
    "name": "The Golden Heptagon",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "ability": "Creatures can play Mugic of any Tribe or affiliation.",
    "flavorText": "At the base of the Citadel, a golden room offers its visitors a taste of an elusive dream...",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/w6NRYVx.png",
    "uniqueId": "The Golden Heptagon__au"
  },
  {
    "id": "186/200",
    "name": "The Magma Dam",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "ability": "Creatures without :fire:Fire have \"Recklessness 5.\"",
    "flavorText": "\"It only needs to hold until Chaor's hordes have amassed!\" — Khybon",
    "unique": false,
    "initiative": "Air",
    "type": "",
    "artist": "Adrian Barrios. Anthony Washington",
    "imageUrl": "https://i.imgur.com/8fdO63z.png",
    "uniqueId": "The Magma Dam__au"
  },
  {
    "id": "190/200",
    "name": "The Passage",
    "subname": "OverWorld",
    "set": "au",
    "rarity": "rare",
    "ability": "The first time a Creature gains an Elemental Type this turn, it gains 10 Energy.",
    "flavorText": "From the warm rays of the inviting sun, the stairs spiral into chilling darkness...",
    "unique": false,
    "initiative": "OverWorld",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/oernXdw.png",
    "uniqueId": "The Passage__au"
  },
  {
    "id": "191/200",
    "name": "The Passage",
    "subname": "UnderWorld",
    "set": "au",
    "rarity": "rare",
    "ability": "The first time a Creature loses an Elemental Type this turn, it loses 10 Energy.",
    "flavorText": "...plunging into the void until a faint glow illuminates from bellow, a light not so inviting.",
    "unique": false,
    "initiative": "UnderWorld",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/r4GRInb.png",
    "uniqueId": "The Passage__au"
  },
  {
    "id": "192/200",
    "name": "The Phlogiston",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "At the beginning of combat, all Creatures gain :fire:Fire.",
    "flavorText": "The land melts, boils and erupts, creating an ever-shifting landscape.",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/JVgIjPu.png",
    "uniqueId": "The Phlogiston__au"
  },
  {
    "id": "197/200",
    "name": "The Storm Tunnel",
    "subname": "Lingering Monsoon",
    "set": "au",
    "rarity": "common",
    "ability": "The engaged Creature with the lowest :speed:Speed plays attacks at random.",
    "flavorText": "The scars of war remain long after the battle is over.",
    "unique": false,
    "initiative": "Water",
    "type": "",
    "artist": "Emilio Lopez, HotShotsVFX, Keith Conroy",
    "imageUrl": "https://i.imgur.com/PxCjxj5.png",
    "uniqueId": "The Storm Tunnel__au"
  },
  {
    "id": "198/200",
    "name": "The Storms",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "ability": "At the beginning of combat, all Creatures gain :air:Air.",
    "flavorText": "\"Someone must have carved these statues. So where are they?\" — Tiaane",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/gg8LCDz.png",
    "uniqueId": "The Storms__au"
  },
  {
    "id": "199/200",
    "name": "The Swartbron",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "ability": "The engaged Creature with the lowest :courage:Courage fails all Checks on attacks it plays.",
    "flavorText": "Night flows like a river here.",
    "unique": false,
    "initiative": "Fire",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/kmlHBCr.png",
    "uniqueId": "The Swartbron__au"
  },
  {
    "id": "10/100",
    "name": "Silchaw's Mine",
    "subname": "",
    "set": "fas",
    "rarity": "rare",
    "ability": "Attacks that would deal more than 20 damage to Creatures with :earth:Earth deal 20 damage instead.",
    "flavorText": "Since Aszil opened the Tremor Gate, the very bedrock of Silchaw's mine has gone mad!",
    "unique": false,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, Anthony Washington",
    "imageUrl": "https://i.imgur.com/3ElZSrO.png",
    "uniqueId": "Silchaw's Mine__fas"
  },
  {
    "id": "12/100",
    "name": "The Flame Gate",
    "subname": "",
    "set": "fas",
    "rarity": "common",
    "ability": "All attacks count as :fire:Fire attacks.",
    "flavorText": "\"Maybe we should look for another way in.\" — Mezzmarr",
    "unique": false,
    "initiative": "Fire",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/4Q6Mgtq.png",
    "uniqueId": "The Flame Gate__fas"
  },
  {
    "id": "P-012",
    "name": "Carnival of Confusion",
    "subname": "The Entangled Throne",
    "set": "promo",
    "rarity": "promo",
    "ability": "When an attack is played, flip a coin. If heads, that attack deals double damage. If tails, that attack deals 0 damage.",
    "flavorText": "Here your fate rests with your fortune.",
    "unique": false,
    "initiative": "Speed",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/KgptD6s.png",
    "uniqueId": "Carnival of Confusion__promo"
  },
  {
    "id": "OP1-18/20",
    "name": "Castle Pillar",
    "subname": "(OP)",
    "set": "op",
    "rarity": "ultra rare",
    "ability": "At the beginning of combat, if an engaged Creature has higher :wisdom:Wisdom than the opposing engaged Creature, put a :genericmugic: on it",
    "flavorText": "It's rumored that the most vicious Creature in Perim is imprisoned here, but only Chaor truly knows.",
    "unique": true,
    "initiative": "Courage",
    "type": "",
    "artist": "Keith Conroy, David Curiel",
    "imageUrl": "https://i.imgur.com/ZYhRlLs.png",
    "uniqueId": "Castle Pillar__op"
  },
  {
    "id": "OP1-19/20",
    "name": "Fear Valley",
    "subname": "(OP)",
    "set": "op",
    "rarity": "uncommon",
    "ability": "At the beginning of combat, if an engaged Creature has lower :courage:Courage than the opposing engaged Creature, it loses 10 Energy.",
    "flavorText": "No matter how far you run, you can never escape a nightmare.",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/YqKqdeq.png",
    "uniqueId": "Fear Valley__op"
  },
  {
    "id": "OP1-20/20",
    "name": "Kiru City",
    "subname": "(OP)",
    "set": "op",
    "rarity": "rare",
    "ability": "OverWorld Creatures have an additional 10 Energy.",
    "flavorText": "\"We will rebuild our home on the ruins of Old Kiru. The UnderWorlders may have destroyed our city, but they can never destroy our spirit!\" — Maxxor",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "Khary Randolph, Anthony Washington",
    "imageUrl": "https://i.imgur.com/CwmhbEh.png",
    "uniqueId": "Kiru City__op"
  },
  {
    "id": "OP-ulwk4j9l",
    "name": "Annex of the Arcane",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "ability": "At the beginning of combat, flip a coin. If heads, put a :genericmugic: on your engaged Creature. If tails, put a :genericmugic: on the opposing engaged Creature.\r\nCreatures with one or more Mugic counters have an additional 10 Energy.",
    "flavorText": "",
    "unique": false,
    "initiative": "Wisdom",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/46WLM8f.png",
    "uniqueId": "Annex of the Arcane__op"
  },
  {
    "id": "OP-t8jtybwa",
    "name": "Khybon's Scrapyard",
    "subname": "",
    "set": "op",
    "rarity": "uncommon",
    "ability": "When a Battlegear is put into a general discard pile, put a Scrap Counter on Khybon's Scrapyard. Then, if it has three or more Scrap counters, return up to one Battlegear Card from your general discard pile to play equipped to an unequipped Creature you control and your opponent reveals a new active Location.",
    "flavorText": "",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "HotShotsVFX",
    "imageUrl": "https://i.imgur.com/2ImweW8.png",
    "uniqueId": "Khybon's Scrapyard__op"
  },
  {
    "id": "DOP-506kmbl3",
    "name": "Glacier Plains",
    "subname": "(Holiday Reward)",
    "set": "dop",
    "rarity": "super rare",
    "ability": "UnderWorld Mugic Costs 1 additional :underworldmugic: to play.",
    "flavorText": "This frozen, remote region is home to Blügon and other frosty Creatures.",
    "unique": false,
    "initiative": "Power",
    "type": "",
    "artist": "Keith Conroy, David Curiel, A Clipart snowman",
    "imageUrl": "https://i.imgur.com/GSAk2UH.png",
    "uniqueId": "Glacier Plains__dop"
  }
];

// Helper functions to work with the database
export const getLocationById = (idOrKey) => {
  // First try direct ID lookup for backward compatibility
  const directMatch = locationDatabase.find(location => location.id === idOrKey);
  if (directMatch) return directMatch;
  
  // Next try uniqueId match
  const uniqueMatch = locationDatabase.find(location => location.uniqueId === idOrKey);
  if (uniqueMatch) return uniqueMatch;
  
  // If not found, check if it's a composite key
  if (idOrKey.includes('__')) {
    const [name, set] = idOrKey.split('__');
    return locationDatabase.find(location => 
      location.name === name && location.set === set
    );
  }
  
  return null;
};

export const getAllLocationNames = () => {
  return locationDatabase.map(location => ({
    id: location.uniqueId || createUniqueCardKey(location), // Use the composite key here
    name: location.name,
    subname: location.subname || '', // Include subname in the list
    set: location.set || '',
    setDisplay: location.set ? location.set.toUpperCase() : '',
    type: location.type || '',
    unique: location.unique || false,
    initiative: location.initiative || '',
    // Keep the original ID for reference
    originalId: location.id
  }));
};
